<template>
    <div>
      <div class="center">
        Correo electrónico a contacto
      </div>

      <div style="margin: 10px 10px 0px 10px">
        <div>
            <v-select
              @change="selectClicked"
              placeholder="Seleccione una opción"
              :items="items"
              label="Contactos"
              v-model="item"
            >
              <template v-slot:selection="{ item, index }">
                <v-chip v-if="index === 0">
                  <span>{{MetodoSeleccion}} {{ item }}</span>
                </v-chip>
              </template>
              <template v-if="item" slot="append-outer">
                <v-btn fab icon x-small @click="correoElectronico"><v-icon>mdi-email</v-icon></v-btn>
              </template>
            </v-select>
        </div>
        <v-textarea hide-details height="80px" outlined dense placeholder=" " >
          <template v-slot:label>
            <div>
              Comentarios <small> (opcional)</small>
            </div>
          </template>
        </v-textarea>
      </div>
  </div>
</template>


<script>
import EventBus from '@/components/event-bus'

export default {
    name: 'PlanReaccionCorreoContactos',
    props:{
        title: String
    },
    data: () => ({
        items: ["prueba@yopmail.com"],
        item: null,
        MetodoSeleccion: null
    }),
    methods: {
        correoElectronico(){
            this.MetodoSeleccion = "Correo a "
            window.location.href='mailto:prueba@yopmail.com'
        },
        selectClicked(){
            //console.log('v-select', this.item)
        },
        ContinueHandler() {
            //console.log("ContinueHandler")
            EventBus.$emit('continue-step');
        }
    }
}
</script>
